import { every } from "lodash";
import { TestQuestionCreate as ITestQuestionCreate } from "@/api/models";
import Vue from "vue";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

export function addQuestion(question: ITestQuestionCreate) {
  const vm = new Vue({});

  let answerBodyEmpty = (element: any) => element.body === "";
  if (!question.body) {
    vm.$bvToast.toast(i18n.tc(LocalesFields.TheQuestionCannotBeEmpty), {
      variant: "danger",
      title: i18n.tc(LocalesFields.Error)
    });
  } else if (question.answers.some(answerBodyEmpty)) {
    vm.$bvToast.toast(i18n.tc(LocalesFields.TheQuestionCannotBeEmpty), {
      variant: "danger",
      title: i18n.tc(LocalesFields.Error)
    });
  } else {
    let answerValueNotRight = every(question.answers, { value: false });
    if (answerValueNotRight) {
      vm.$bvToast.toast(i18n.tc(LocalesFields.AtLeastOneAnswerMustBeCorrect), {
        variant: "danger",
        title: i18n.tc(LocalesFields.Error)
      });
    } else {
      return true;
    }
  }
}
